module.exports = __webpack_public_path__ + "static/media/w-01.242f7d71.png";